import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { GET, GET_REPORT_CAMPAIGN_USED } from '../../../services';

export const useGetReportCampaignFull = ({ handleSubmit }) => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearchFull } = useMutation({
    mutationFn: async (searchParamState) => {
      const { search } = searchParamState;
      const response = await GET(
        GET_REPORT_CAMPAIGN_USED({
          search: search || '',
          startDate: '',
          endDate: '',
        }),
      );
      return response?.result?.item || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
  });

  const onFetchFull = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();

  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetchFull };
};
